<template>
  <div class="page stop-calls" v-if="!manifest.hideNextPassages">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'StopCalls' | lang }}</div>
    </header>
    <div v-if="isConnected">
      <div class="form-grid-1-2">
        <place-picker v-model="placeFrom" :label="'Origin' | lang" :coords="true" class="double"/>
        <div class="floating-label">
          <select v-model="line" placeholder=" " type="text">
            <option :value="null">{{ 'AllF' | lang }}</option>
            <option v-for="(l, lidx) in lines" :value="l" :key="lidx">{{l.Alias}}</option>
          </select>
          <label>{{ 'Line' | lang }}</label>
        </div>
        <div class="floating-label">
          <input v-model="stopname" placeholder=" " />
          <label>{{ 'Stop' | lang }}</label>
        </div>
      </div>
      <div v-if="lastUpdate" class="space-between" style="margin-bottom: 1rem"><span>{{ 'LastUpdate' | lang }}:</span><span v-timeago="lastUpdate"></span></div>
      <div class="multi-nav">
        <div v-for="(s, i) in stopsFiltered" :key="i">
          <!-- <div v-content-attached-on-top class="nav-header hflex" :key="s.Name">
            {{s.Name}}
            <div class="hspace"></div>
            <span class="text-small">{{s.dist.toFixed(2)}}km</span>
          </div> -->
          <div v-content-attached-on-top class="nav-header hflex" :key="s.Name" @click="toggleStop(s)">
            <div>
              {{s.Name}}
              <br />
              <span class="text-small">{{s.Distance.toFixed(0)}}mt</span>
            </div>
            <div class="hspace"></div>
            <!-- <div class="lines-by-stop">
              <i v-for="l in s.Lines" :key="l.Alias" class="fa fa-circle" :style="{ color: l.Background }"></i>
            </div> -->
            <div v-if="openStops[s.Code] === true" @click.stop="">
              <i class="fa fa-fw fa-refresh fa-spin"></i>
            </div>
            <div @click.stop="openMapApp(s)" v-else-if="openStops[s.Code]">
              <i class="fa fa-fw fa-street-view"></i>
            </div>
            <div v-else>
              <i class="fa fa-fw fa-chevron-down"></i>
            </div>
          </div>
          <div v-if="!openStops[s.Code] || openStops[s.Code] === true">&nbsp;</div>
          
          <ul class="nav" :key="s.Name + 'nav'" v-else-if="filterPassagesByLine(openStops[s.Code]).length > 0">
            <li v-for="(sc, idx) in filterPassagesByLine(openStops[s.Code])" :key="idx">
              <div class="gridtest">
                
                <div style="grid-area:hour">
                  <label class="small-text desktop-only" style="padding-top: .5rem">{{ sc.IsForecasted ? 'stopCallForecasted' : 'stopCallAimed' | lang }}</label>
                  <div>
                    <span style="display:initial">{{sc.Arrival | time}}</span>
                    <span style="display:initial" v-if="sc.secondsFromNow < 90"> ({{ 'Incoming' | lang }})</span>
                    <label class="small-text mobile-only" style="margin-left:.5rem">{{ sc.IsForecasted ? 'stopCallForecasted_short' : 'stopCallAimed_short' | lang }}</label>
                  </div>
                </div>
                
                <div class="line-box">
                  <div :style="{ color: invertColor(sc.Line.Background), backgroundColor: sc.Line.Background }">
                    <label class="small-text desktop-only" style="font-weight:bold">{{ 'Line' | lang }}</label>
                    <div style="font-weight:bold">{{sc.Line.Alias}}</div>
                  </div>
                </div>

                <div style="grid-area:destination">
                  <label class="small-text desktop-only">{{ 'Terminal' | lang }}</label>
                  <div>{{sc.Destination}}</div>
                </div>
              </div>
            </li>
          </ul>
          <div v-else><ul class="nav"><li>{{ 'NoPassage' | lang }}</li></ul></div>
          <!-- <div v-else><ul class="nav"><li>{{ 'PassagesUnavailable' | lang }}</li></ul></div> -->
        </div>
      </div>
    </div>
    <div v-else class="flexcentered bigger">{{ 'ConnectionRequired' | lang }}</div>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import stopServices from '@/mixins/services/stopServices'
import PlacePicker from '@/components/PlacePicker.vue'
import moment from 'moment'

let haversineFormula = (lat1, lon1, lat2, lon2) => {
       var R = 6378.137; // Radius of earth in KM
       var dLat = lat2 * Math.PI / 180 - lat1 * Math.PI / 180
       var dLon = lon2 * Math.PI / 180 - lon1 * Math.PI / 180
       var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                Math.sin(dLon/2) * Math.sin(dLon/2)
       var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a))
       var d = R * c
       return d // kilometers
}

export default {
  name: 'StopCalls',
  mixins: [ page, stopServices ],
  components: { PlacePicker },
  data () {
    return {
      loading: true,
      results: [],
      lastUpdate: null,
      placeFrom: null,
      line: null,
      stopname: null,
      openStops: {},
      stops: []
    }
  },
  computed: {
    lines () {
      let lines = {}
      this.stops.forEach(stop => {
        stop.Lines.forEach(line => {
          lines[line.Alias] = line
        })
      })
      return Object.values(lines)
      // return [...new Set(this.list.reduce((lst, el) => lst.concat(el.NextPassages && el.NextPassages.length ? el.NextPassages.map(passage => passage.Line) : []), []))]
    },
    stopsFiltered () {
      let lst = this.stops
      if (this.stopname) {
        let stopNameLowerCase = this.stopname.toLowerCase()
        lst = lst.filter(stop => stop.Name.toLowerCase().indexOf(stopNameLowerCase) > -1)
      }
      if (this.line) {
        lst = lst.filter(stop => {
          return stop.Lines.find(line => line.Alias === this.line.Alias)
        })
      }
      return lst
    }
    /* sortedResults () {
      let lst = this.results.slice()
      lst.sort((a,b) => a.realtime > b.realtime ? 1 : -1)
      return lst
    }, */
    /* lastUpdateHuman () {
      if (this.lastUpdate) {
        return this.lastUpdate.format('HH:mm:ss')
      }
      return null
    } */
  },
  methods: {
    toggleStop (stop) {
      if (!this.openStops[stop.Code]) {
        this.$set(this.openStops, stop.Code, true)
        this._getStopCalls2(stop.Code).then(data => {
          // this.lastUpdate = moment()
          this.$set(this.openStops, stop.Code, data)
        }).catch(err => {
          console.warn(err)
          this.$set(this.openStops, stop.Code, undefined)
        })
      } else {
        this.$set(this.openStops, stop.Code, undefined)
      }
    },
    filterPassagesByLine (passages) {
      if (this.line) {
        return passages.filter(passage => passage.Line.Alias === this.line.Alias)
      }
      return passages
    },
    openMapApp (stop) {
      let url = this.isIOS ? `http://maps.apple.com/?q=${stop.Latitude},${stop.Longitude}&z=8` : `https://maps.google.com/?q=${stop.Latitude},${stop.Longitude}&z=8`
      window.open(url, '_blank')
      // window.open(`geo:${stop.stop_lat},${stop.stop_lon}`, '_blank')
    },
    getCalls () {
      this._getStopCalls(this.placeFrom.latlng.lat, this.placeFrom.latlng.lng, this.stopRadius).then(data => {
        this.lastUpdate = moment()
        data.forEach(pt => {
          // console.log(pt.Latitude, pt.Longitude, this.placeFrom.latlng.lat, this.placeFrom.latlng.lng)
          pt.dist = haversineFormula(pt.Latitude, pt.Longitude, this.placeFrom.latlng.lat, this.placeFrom.latlng.lng)
        })
        this.results.splice(0, this.results.length, ...data)
        this.$nextTick(this.checkFilters)
      })
    },
    checkFilters () {
      if (this.line && this.lines.indexOf(this.line) === -1) {
        this.line = null
      }
    },
    setRouteError (errorKey) {
      this.internalBus.$emit('notify:error', {
        text: this.dictValue(errorKey || 'errorOccured'), // this.dictValue('errorOccured'),
        key: this.notifierKey
      })
      /* this.routesFound = []
      this.routesResult.status = false
      this.routesResult.errorMessage = errorKey */
    },
    async updateNearbyStops () {
      if (this.placeFrom.is_cp) {
        try {
          let result = await this.getCurrentPosition()
          this.placeFrom = { latlng: { lat: result.coords.latitude, lng: result.coords.longitude }, description: this.dictValue('CurrentPosition') }
        } catch (result) {
          if (result.code === 0) {
            this.setRouteError('CurrentLocationErrorGeneric')
            return
          } else if (result.code === 1) {
            this.setRouteError('CurrentLocationErrorPermissionDenied')
            return
          } else if (result.code === 2) {
            this.setRouteError('CurrentLocationErrorUnavailable')
            return
          } else if (result.code === 3) {
            this.setRouteError('CurrentLocationErrorTimeout')
            return
          }
        }
      }
      this._getNearbyStops(this.placeFrom.latlng.lat, this.placeFrom.latlng.lng, this.stopRadius).then(response => {
        response.forEach(stop => {
          stop.Distance = (stop.Distance || 0) // / 1000
        })
        this.stops.splice(0, this.stops.length, ...response)
      })
    }
  },
  mounted () {
    this.placeFrom = { is_cp: true, description: this.dictValue('CurrentPosition') }
    // this.getCalls()
    // this.restartInterval()
    setTimeout(() => {
      this.loading = false
    }, 500 + Math.random() * 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  watch: {
    placeFrom () {
      this.updateNearbyStops()
      this.stopname = null
      this.line = null
    }
  }
}
</script>

<style lang="scss">

.gridtest {
  width: 100%;
  display: grid;
  /* grid-template-columns: auto 1fr auto;
  grid-auto-flow: row; */
  grid-template-columns: 1fr auto;
  grid-column-gap: .5rem;
  grid-template-areas:
    'hour line'
    'destination destination';

    .line-box {
      grid-area: line;
      
      & > div {
        padding: .3rem .5rem;
        min-width: 3.5rem;
        text-align: center;
      }
    }
}

.small-text {
  font-size: 80%;
}

.stop-calls {
  .border-but-top {
    padding: .5rem;
    padding-top: 0;
    border: 1px solid;
    border-top: none;
  }
  .border-but-bottom {
    padding: .5rem;
    padding-bottom: 0;
    border: 1px solid;
    border-bottom: none;
  }
}

.lines-by-stop {
  display: grid;
  grid-template-rows: auto auto auto;
  grid-auto-flow: column;

  i {
    font-size: 0.7rem;
    margin: .1rem;
    text-shadow: 0 0 1px var(--white);
  }
}

#app.mobile .stop-calls {
  .nav li {
    padding-left: 0;
    padding-right: 0;

    .gridtest {
      grid-template-columns: auto 1fr;
      grid-template-areas: 'line hour' 'line destination';
    }
  }
}

</style>
